import { Col, Image, Row, Tag, Typography } from "antd";
import { FC } from "react";
import { useGetInvoiceDetails } from "../../ServerSideStates";
import GeneralLoadingSpinner from "apps/Common/GeneralLoadingSpinner";
import dayjs from "dayjs";
import {  AuditOutlined, HomeOutlined } from "@ant-design/icons";
import PageTitle from "apps/Common/PageTitle";

const Header: FC<{ selectedRecord: null | any }> = ({ selectedRecord }) => {
  const { Text } = Typography;
  const invoiceDetails = useGetInvoiceDetails(selectedRecord?.id);
  const invoiceDetailsData = invoiceDetails?.data?.data || null;

  const handleDetermineTagColor = (paymentId: number) => {
    switch (paymentId) {
      case 1:
        return "blue";
      case 2:
        return "green";
      case 3:
        return "error";
      case 4:
        return "error";
    }
  };
  return (
    <>
      <Row className="">
        {invoiceDetails?.isLoading || invoiceDetails.isFetching ? (
          <>
            <GeneralLoadingSpinner />
          </>
        ) : (
          <>
            <Col xs={24}>
              <Row gutter={[60, 40]}>
                <Col
                  xs={24}
                  lg={14}
                  className=""
                  style={{ borderRight: "1px solid black" }}
                >
                  <Row gutter={[0, 5]}>
                    <Col xs={24}>
                    <PageTitle
                    title=" Fatura:"
                    />
                     
                    </Col>
                    <Col xs={24}>
                      <Text className="!text-xl !text-black !font-bold ">{`${
                        invoiceDetailsData?.user?.name || ""
                      } ${invoiceDetailsData?.user?.surname || ""}`}</Text>
                    </Col>

                    <Col xs={24}>
                      <Text className="!text-sm">
                        {invoiceDetailsData?.user?.eMail || ""}
                      </Text>
                    </Col>
                    <Col xs={24}>
                      <Text className="!text-sm">
                        {invoiceDetailsData?.user?.phoneNumber || ""}
                      </Text>
                    </Col>
                  </Row>
                </Col>
                <Col xs={24} lg={10}>
                  <div className="!flex gap-2 items-center">
                    <div>
                      <Text className="!font-bold !text-xl md:!text-2xl  xl:!text-4xl !text-[#050505] ">
                        SariIlanlar
                      </Text>
                    </div>
                  </div>
                  <div className="!mt-4 !flex gap-1 items-center ">
                    <AuditOutlined className="!text-xl"/>
                    <Text className="!text-xs">
                    SARI İLANLAR BİLGİ TEKNOLOJİLERİ PAZ. VE DIŞ TİCARET A.Ş.
                    </Text>
                  </div>
                  <div className="!mt-4 !flex gap-1 items-center ">
                    <HomeOutlined  className="!text-xl"  />
                    <Text className="!text-xs">
                    KDENİZ MAH. ŞEHİT FETHİ BEY CAD. HERİS TOWER NO:55/091
                    KONAK/İZMİR
                    </Text>
                  </div>
                </Col>
                <Col xs={24} className="">
                  <Row gutter={[60, 20]}>
                    <Col xs={24} lg={14}>
                      <Text className=" !text-xl md:!text-2xl  xl:!text-4xl xxl:!text-6xl">Fatura</Text>
                    </Col>
                    <Col xs={24} lg={10} className="!grid gap-2">
                      <div className="!flex gap-4">
                        <Text className="!text-sm !font-bold">Fatura #</Text>
                        <Text className="!text-sm">
                          {invoiceDetailsData?.code}
                        </Text>
                      </div>
                      <div className="!flex gap-4">
                        <Text className="!text-sm !font-bold ">Tarih</Text>
                        <Text className="!text-sm">
                          {dayjs(invoiceDetailsData?.insertDate).format(
                            "DD.MM.YYYY"
                          )}
                        </Text>
                      </div>
                      <div className="!flex gap-4">
                        <Text className="!text-sm !font-bold ">
                          Ödeme Durumu
                        </Text>
                        <Text className="!text-sm">
                          <Tag
                            color={handleDetermineTagColor(
                              invoiceDetailsData?.paymentStatusId
                            )}
                          >
                            {invoiceDetailsData?.paymentStatus?.name}
                          </Tag>
                        </Text>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </>
        )}
      </Row>
    </>
  );
};

export default Header;
